import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ServiceCard from '../components/ServiceCard';

export default function Services() {
  const { t } = useTranslation('marketing');

  const allServices = [
    {
      id: 'longevity',
      title: t('services.allServices.longevity.title'),
      description: t('services.allServices.longevity.description'),
      icon: 'favorite',
      image: '/images/service-longevity.jpeg'
    },
    {
      id: 'wellness',
      title: t('services.allServices.wellness.title'),
      description: t('services.allServices.wellness.description'),
      icon: 'health_and_safety',
      image: '/images/service-wellness.jpeg'
    },
    {
      id: 'personalized',
      title: t('services.allServices.personalized.title'),
      description: t('services.allServices.personalized.description'),
      icon: 'assignment',
      image: '/images/service-personalized.jpg'
    },
    {
      id: 'monitoring',
      title: t('services.allServices.monitoring.title'),
      description: t('services.allServices.monitoring.description'),
      icon: 'trending_up',
      image: '/images/service-monitoring.jpg'
    },
    {
      id: 'concierge',
      title: t('services.allServices.concierge.title'),
      description: t('services.allServices.concierge.description'),
      icon: 'star',
      image: '/images/service-concierge.jpg'
    },
    {
      id: 'retreat',
      title: t('services.allServices.retreat.title'),
      description: t('services.allServices.retreat.description'),
      icon: 'landscape',
      image: '/images/service-retreat.jpg'
    },
    {
      id: 'genetic',
      title: t('services.allServices.genetic.title'),
      description: t('services.allServices.genetic.description'),
      icon: 'dna',
      image: '/images/service-genetic.jpg'
    },
    {
      id: 'nutrition',
      title: t('services.allServices.nutrition.title'),
      description: t('services.allServices.nutrition.description'),
      icon: 'restaurant',
      image: '/images/service-nutrition.jpg'
    }
  ];

  const whyChoose = [
    {
      id: 'science',
      title: t('services.why.scienceBacked.title'),
      description: t('services.why.scienceBacked.description'),
      icon: 'verified'
    },
    {
      id: 'experts',
      title: t('services.why.expertTeam.title'),
      description: t('services.why.expertTeam.description'),
      icon: 'people'
    },
    {
      id: 'holistic',
      title: t('services.why.holistic.title'),
      description: t('services.why.holistic.description'),
      icon: 'wellness_center'
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-primary to-primary-container py-20 px-margin-mobile">
        <div className="max-w-container-max mx-auto text-center">
          <h1 className="text-display-lg text-on-primary mb-6">{t('services.hero.title')}</h1>
          <p className="text-headline-md text-on-primary/90 max-w-2xl mx-auto">
            {t('services.hero.subtitle')}
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-section-gap px-margin-mobile bg-background">
        <div className="max-w-container-max mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {allServices.map((service) => (
              <ServiceCard
                key={service.id}
                {...service}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Wellis Section */}
      <section className="py-section-gap px-margin-mobile bg-primary-container">
        <div className="max-w-container-max mx-auto">
          <h2 className="text-display-md text-on-primary-container mb-12 text-center">
            {t('services.why.heading')}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {whyChoose.map((item) => (
              <div key={item.id} className="text-center">
                <div className="mb-4 inline-block p-4 bg-accent/20 rounded-full">
                  <span className="material-symbols-outlined text-accent text-4xl">{item.icon}</span>
                </div>
                <h3 className="text-headline-md text-on-primary-container mb-2">{item.title}</h3>
                <p className="text-body-md text-on-primary-container/80">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-primary text-on-primary py-section-gap px-margin-mobile">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-display-md mb-6">{t('services.cta.heading')}</h2>
          <p className="text-headline-md mb-12 opacity-90">
            {t('services.cta.description')}
          </p>

          <Link
            to="/contact"
            className="inline-block px-12 py-4 bg-accent text-on-accent rounded-full font-bold text-label-lg uppercase tracking-widest hover:opacity-90 transition-opacity"
          >
            {t('services.cta.button')}
          </Link>
        </div>
      </section>
    </div>
  );
}
